import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { LoanDetails } from '../../../services/requests';
import { View } from '../../../shared/components';
import { Card, CardBody } from '@Comp';
import { ListGroup, Col, Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import ViewUploadedFiles from '../../business-profile-copy/ViewUploadeFiles';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import numeral from 'numeral';

@inject('businessProfileStore', 'loanStore', 'viewStore', 'commonStore')
@observer
@withRouter
class Loanview extends Component {
    constructor() {
        super();
        this.state = {
            loanData: '',
            showUploader: false,
            uploadingSignedDoc: false
        };
    }
    processLoanData = (data) => {
        // Normalize invoice to array
        let invoice = [];
        if (data.invoice) {
            if (Array.isArray(data.invoice)) {
                invoice = data.invoice;
            } else {
                invoice = [data.invoice];
            }
        }
        data.invoice = invoice;

        // Set offer data if offer is accepted
        if (data.offerStatus === 'accepted' && data.acceptedOffer && data.offers) {
            const accepted = data.offers.find(offer => offer.id === data.acceptedOffer || offer._id === data.acceptedOffer);
            if (accepted) {
                data.status = accepted.status;
                data.offer = accepted;
            }
        }

        return data;
    };

    async componentDidMount() { //NOSONAR
        this.props.commonStore.setLoading(true);
        const { loanId } = this.props.match.params;
        const { showOffer = false } = this.props;
        //from offers screen
        if (loanId && !showOffer) {
            const response = await LoanDetails.get(loanId);
            if (response && response.data) {
                const processedData = this.processLoanData(response.data);
                this.setState({ loanData: processedData });
            }
        }
        if (showOffer) {
            const processedData = this.processLoanData(showOffer);
            this.setState({ loanData: processedData });
        }
        this.props.commonStore.setLoading(false);

    }

    linkFormatter = loanData => {
        const { history, viewStore } = this.props;
        if (!loanData.status || typeof loanData.status !== 'object' || !loanData.status.name) {
            return null;
        }
        switch (loanData.status.name) {
            // Allow Editing
            case 'Not Verified':
                return (
                    <div
                        onClick={() => {
                            // Edit
                            viewStore.setEditLoanDetails(loanData);
                            history.push('/home/loan/apply');
                        }}
                        className="cursor text-center btn btn-info mt-3 float-right"
                    >
                        Update Loan Application
                    </div>
                );
            // Go to Offers Page
            case 'Awaiting offer acceptance':
                return (
                    <div
                        onClick={() => {
                            viewStore.setLoanOffersState({ loanAppl: { ...loanData } });
                            history.push(`/home/loan/offers/${loanData._id}`);
                        }}
                        className="cursor text-center btn btn-primary mt-3 float-right"
                    >
                        View Offers
                    </div>
                );
            // Manual Signature Flow
            // case 'Awaiting Signature':
            //     return (
            //         <div className="text-right mt-3">
            //             <p className="text-muted mb-2">
            //                 Please download the loan agreement, sign it, and upload the signed document.
            //             </p>
            //         </div>
            //     );

            default:
                break;
        }

        return null;
    };
    handleRemoveDocument = (e, ID) => {
        const { loanData } = this.state;
        const invoices = loanData.invoice.filter(document => document._id !== ID);
        this.setState({ loanData: { ...this.state.loanData, invoice: invoices } });
    };

    handleDropzoneSubmit = async (files, allFiles) => {
        if (!files || files.length === 0) return;

        const file = files[0].file;
        await this.handleSignedDocumentUpload(file);

        // Remove files from dropzone after upload
        allFiles.forEach(f => f.remove());
    };

    handleSignedDocumentUpload = async (file) => {
        const { loanData, uploadingSignedDoc } = this.state;
        const { commonStore } = this.props;

        if (uploadingSignedDoc || !file || !loanData.offer) return; // Prevent multiple uploads

        try {
            this.setState({ uploadingSignedDoc: true });
            commonStore.setLoading(true);

            const offerId = loanData.offer?.id || loanData.offer?._id;

            // Prepare form data for file upload
            const formData = new FormData();
            formData.append('files', file);

            // Call the custom backend endpoint
            const config = await import('../../../constants/config');
            const baseURL = config.default.BASE_URL;
            const token = localStorage.getItem('tkn');

            const uploadResponse = await fetch(`${baseURL}/offers/upload-signed-document/${offerId}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            });

            if (!uploadResponse.ok) {
                throw new Error(`Upload failed with status: ${uploadResponse.status}`);
            }

            const result = await uploadResponse.json();

            // Refresh loan data to get updated status and documents
            const refreshedLoan = await LoanDetails.get(loanData._id);
            if (refreshedLoan && refreshedLoan.data) {
                const processedData = this.processLoanData(refreshedLoan.data);

                // Add audit trail for document signed - SME side
                if (processedData.status && processedData.status.id) {
                    await commonStore.addAuditTrail(
                        processedData.status.id || processedData.status._id,
                        null, // Will use profile from localStorage (SME profile)
                        'loan',
                        {
                            loandetail: loanData._id,
                            offer: offerId,
                            smeProfile: null // Will be set from localStorage
                        }
                    );
                }

                // Add audit trail for POF side
                if (processedData.status && processedData.status.id && processedData.offer && processedData.offer.pofProfile) {
                    const pofProfileId = processedData.offer.pofProfile.id || processedData.offer.pofProfile._id;
                    if (pofProfileId) {
                        await commonStore.addAuditTrail(
                            processedData.status.id || processedData.status._id,
                            pofProfileId, // POF profile ID
                            'loan',
                            {
                                loandetail: loanData._id,
                                offer: offerId,
                                pofProfile: pofProfileId
                            }
                        );
                    }
                }

                this.setState({
                    loanData: processedData,
                    showUploader: false,
                    uploadingSignedDoc: false
                });

                // Show success message like other uploaders
                await commonStore.setMsg('Signed document uploaded successfully. Status updated to "Loan Agreement Document Signed".');
            }

            commonStore.setLoading(false);
        } catch (error) {
            console.error('Error uploading signed document:', error);
            commonStore.setLoading(false);
            this.setState({ uploadingSignedDoc: false });
            await commonStore.setMsg('Error uploading signed document. Please try again.');
        }
    };

    render() {//NOSONAR
        const { loanData } = this.state;
        const { showOffer = false } = this.props;
        //from offers screen
        const { acceptedOffer } = loanData;
        let provider = '';
        if (acceptedOffer) {
            const offerRes = loanData.offers.filter(offer => offer.id === acceptedOffer);
            provider = offerRes && offerRes[0]['financialProvider'];
        }
        return (
            loanData && (
                <>
                    <View showOffer={showOffer}>
                        {!showOffer && (<div className="view-header">
                            <header className="title text-white">
                                <h1 className="h4 text-uppercase">Loans</h1>
                                <p className="mb-0">
                                    Loan Application Number : {loanData && loanData._id}
                                </p>
                            </header>
                        </div>)}
                        <div className="view-content view-components">
                            <Card className="mb-4">
                                <CardBody className="table-responsive">

                                    <Row>
                                        <Col>
                                            <h3 className="mb-4 text-uppercase">
                                                <span className="badge badge-primary p-3">
                                                    Loan Application Details
                                    </span>
                                            </h3>
                                            <hr />
                                            <ListGroup>
                                                <ListGroup.Item>
                                                    <strong>Application Number </strong>: {loanData._id}
                                                </ListGroup.Item>

                                                <ListGroup.Item>
                                                    <strong>Application Status </strong>:
                                        {loanData.status && typeof loanData.status === 'object' && (
                                                        <div
                                                            className="badge badge-pill text-white"
                                                            style={{ backgroundColor: loanData.status.color || '#6c757d' }}
                                                        >
                                                            {loanData.status.smeTitle || loanData.status.name || 'Unknown'}
                                                        </div>
                                                    )}
                                                </ListGroup.Item>
                                                {loanData.status && loanData.status.name === 'Awaiting offer acceptance' && (
                                                    <ListGroup.Item>
                                                        <strong>Offer Acceptance Status </strong>:
                                                        <div
                                                            className="badge badge-pill text-white"
                                                            style={{ backgroundColor: loanData.status.color || '#6c757d' }}
                                                        >
                                                            {loanData.offerStatus}

                                                        </div>
                                                        {loanData.offerStatus === 'accepted' &&
                                                            <div
                                                                className="badge badge-pill text-white ml-2"
                                                                style={{ backgroundColor: '#2f7fb6' }}
                                                            >
                                                                {provider}

                                                            </div>}
                                                    </ListGroup.Item>
                                                )}

                                                <ListGroup.Item>
                                                    <strong>Requested Loan Type </strong>:
                                        {loanData.factoring && 'Purchase Order'}
                                                    {loanData.discounting && 'Invoice'}
                                                </ListGroup.Item>

                                                <ListGroup.Item>
                                                    <strong>Invoice Amount </strong>: {loanData.invoiceAmount}
                                                </ListGroup.Item>

                                                <ListGroup.Item>
                                                    <strong>Invoice Due Date </strong>:
                                        {new Date(loanData.invoiceDueDate).toDateString()}
                                                </ListGroup.Item>

                                                <ListGroup.Item>
                                                    <strong>Buyer </strong>: {loanData.buyer}
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <strong>Buyer Telephone Number</strong>: {loanData.contactPerson}
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <strong>Buyer Email</strong>: {loanData.buyerEmail}
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <strong>Loan Description</strong>: {loanData.loanDescription}
                                                </ListGroup.Item>

                                                <ListGroup.Item>
                                                    <strong>Buyer Relationship </strong> :
                                        {loanData.buyerRelationship === 'supplyChain' && ' Part of supply chain'}
                                                    {loanData.buyerRelationship === 'procurement' && ' Procurement of goods/services'}
                                                </ListGroup.Item>

                                                {/* <ListGroup.Item>
                                                    <strong>Invoice Percent For Loan </strong>:
                                        {loanData.loanPercent} %
                                    </ListGroup.Item> */}

                                                <ListGroup.Item>
                                                    <strong>Loan Amount </strong>: R {numeral(loanData.loanAmount).format('0,0.00')}
                                                </ListGroup.Item>
                                            </ListGroup>
                                            {loanData.invoice.length > 0 && (
                                                <div className="my-2 float-left">
                                                    <ViewUploadedFiles
                                                        title="Invoice P/O"
                                                        data={loanData.invoice}
                                                        handleRemoveDocument={this.handleRemoveDocument}
                                                        removable={true}
                                                    />
                                                </div>
                                            )}
                                            {loanData.offer && loanData.offer?.eversign_url && (
                                                <a
                                                    className="btn btn-info my-2 float-right"
                                                    href={loanData.offer?.eversign_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    download
                                                >
                                                    Download Signed Loan Agreement
                                                </a>
                                            )}

                                            {/* Manual Signature Flow - Show download and upload when status is Awaiting Signature */}
                                            {loanData.offer && !loanData.offer?.requiresMultipleSigners && loanData.status && loanData.status.name === 'Awaiting Signature' && loanData.offer?.docs && loanData.offer?.docs.length > 0 && (
                                                <div className="clearfix w-100 my-3" style={{ width: '100%' }}>
                                                    <div className="card" style={{ width: '100%' }}>
                                                        <div className="card-header bg-light">
                                                            <h5 className="mb-0 text-primary">Loan Agreement - Manual Signature Required</h5>
                                                        </div>
                                                        <div className="card-body" style={{ width: '100%' }}>
                                                            {/* Download unsigned agreement */}
                                                            {/* <div className="mb-3" style={{ width: '100%' }}>
                                                                <h6 className="font-weight-bold mb-3">Step 1: Download Unsigned Agreement</h6>
                                                                <ViewUploadedFiles
                                                                    title=""
                                                                    data={loanData.offer?.docs}
                                                                    removable={false}
                                                                />
                                                            </div> */}
{/* 
                                                            <hr /> */}

                                                            {/* Upload signed agreement */}
                                                            <div  style={{ width: '100%' }}>
                                                                <h6 className="font-weight-bold mb-2">Step 1: Upload Signed Agreement</h6>
                                                                <p className="text-muted small mb-3">
                                                                    After signing the agreement, please upload it here.
                                                                </p>
                                                                {this.state.showUploader ? (
                                                                    <Dropzone
                                                                        onSubmit={this.handleDropzoneSubmit}
                                                                        accept="application/pdf"
                                                                        maxFiles={1}
                                                                        multiple={false}
                                                                        inputContent="Drop PDF file or click to browse"
                                                                        styles={{
                                                                            dropzone: {
                                                                                minHeight: 130,
                                                                                maxHeight: 180,
                                                                                border: '2px dashed #007bff',
                                                                                borderRadius: '4px',
                                                                                backgroundColor: '#f8f9fa',
                                                                                overflow: 'auto',
                                                                            },
                                                                            submitButtonContainer: {
                                                                                marginTop: 10,
                                                                                padding: 0
                                                                            },
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div className="d-flex justify-content-between">  
                                                                    <button
                                                                        className="btn btn-success"
                                                                        onClick={() => this.setState({ showUploader: true })}
                                                                    >
                                                                        Upload Signed Document
                                                                    </button>

                                                                    <ViewUploadedFiles
                                                                    title="View Loan Agreement"
                                                                    data={loanData.offer?.docs}
                                                                    removable={false}
                                                                />
                                                                    </div>
                                                                    
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-block w-100" style={{ clear: 'both' }}></div>
                                            <div className="row justify-content-between mt-3 mx-2">
                                                {loanData.id && !showOffer && (
                                                    <div className="text-sm-left mt-3">
                                                        <button
                                                            className="btn btn-danger "
                                                            onClick={() => this.props.history.push('/home/loan/view')}
                                                        >
                                                            Back
                                    </button>
                                                    </div>
                                                )}
                                                <div>{loanData.status && this.linkFormatter(loanData)}</div>
                                            </div>
                                        </Col>
                                        {loanData.offerStatus === 'accepted' && loanData.offer &&
                                            <Col>
                                                <h3 className="mb-4">
                                                    <span className="badge badge-primary p-3">
                                                        {(showOffer && 'Offer Details') || 'Accepted offer details'}
                                                    </span>
                                                </h3>
                                                <hr />
                                                <ListGroup>
                                                    <ListGroup.Item>
                                                        <strong>POF  </strong> :  {typeof (loanData.offer.pofProfile) === 'object' && loanData.offer.pofProfile?.businessName || 'Unknown Provider'}
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Total Repayable </strong> :  R {numeral(loanData.offer?.totalRepayable).format('0,0.00')}
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Monthly Repayable </strong> :  R {numeral(loanData.offer?.monthlyRepayable).format('0,0.00')}
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Additional fee </strong> :  R {numeral(loanData.offer?.aditionalFees).format('0,0.00')}
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Interest </strong> :   {numeral(loanData.offer?.interest).format('0,0.00')} %
                                </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Terms </strong> :  {loanData.offer?.terms}
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Total PaidBack </strong> : R {(Array.isArray(loanData.offer?.payments) &&
                                                            numeral(loanData.offer?.payments.reduce((acc, cur) => acc + Number(cur.amount), 0) || 0).format('0,0.00'))}
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        <strong>Loan to Value (% LTV ) </strong>:
                                        {loanData.offer?.loanPercent || loanData.loanPercent} %
                                    </ListGroup.Item>

                                                    <ListGroup.Item>
                                                        <strong>Loan Amount </strong>: R {numeral(loanData.offer?.loanAmount || loanData.loanAmount).format('0,0.00')}
                                                    </ListGroup.Item>
                                                </ListGroup>
                                                {loanData.offer?.docs && (
                                                    <div className="my-2">
                                                        <ViewUploadedFiles
                                                            title="Original agreement document from Financier"
                                                            data={loanData.offer?.docs}
                                                            removable={true}
                                                            btnTitle='View original agreement'
                                                        />
                                                    </div>
                                                )}
                                            </Col>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>

                    </View>
                </>
            )
        );
    }
}

export default Loanview;
